import { genericThreadAction, alertCreate } from './genericThreadActionCreator';
import actionTypes from '../../actionTypes';
import { fetch } from '../../../api';

const deleteThreads = function deleteThreads(messageIds) {
  const config = {
    fetchData: deleteThreads.fetchData,
    actionCreators: deleteThreads.actionCreators,
    arg: { messageIds },
  };
  return (dispatch, getState) => genericThreadAction({ dispatch, getState, ...config });
};

deleteThreads.fetchData = async function deleteThreadsFetchData({ arg: { messageIds } }) {
  const { payload } = await fetch(
    'messages/hide',
    { method: 'POST', body: JSON.stringify({ messageIds }) }
  );

  return payload;
};

deleteThreads.actionCreators = {
  failure: function deleteThreadsFailureActionCreator({ error }) {
    return alertCreate({ error, type: actionTypes.THREAD_BULK_DELETE_FAILURE });
  },
};

export default deleteThreads;



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/threads/deleteThreads.js